import { createSelector } from "@reduxjs/toolkit";

export const getLocalOrder = createSelector(
  (state) => state.localOrder.list,
  (list) => list
);
